import { cn } from '@/lib/utils';

interface UploadTaskBadgeProps {
  count: number;
  /**
   * 定位与间距由调用方决定：
   * - 侧边栏折叠态：`absolute -top-1 -right-2`（贴图标右上角）
   * - 侧边栏展开态：`absolute top-1/2 right-8 -translate-y-1/2`（与 chevron 留出间距）
   * - 浮层 / 行内：`ml-2 shrink-0`
   */
  className?: string;
}

/**
 * 红色计数角标（纯展示，不带定位）。
 *
 * 不使用 `SidebarMenuBadge`：它自带 `absolute right-1`，且 `top` 依赖
 * `peer-data-[size=*]/menu-button` 变体（只有 `SidebarMenuButton` 才是该 peer），
 * 用在子菜单里会因拿不到 `top` 而掉到行下方。
 */
export function UploadTaskBadge({ count, className }: UploadTaskBadgeProps) {
  if (count <= 0) return null;
  return (
    <span
      data-slot="upload-task-badge"
      className={cn(
        'pointer-events-none inline-flex min-w-4.5 items-center justify-center rounded-full',
        'bg-destructive px-1 text-[10px] leading-4.5 font-medium text-white tabular-nums',
        className
      )}
    >
      {count > 99 ? '99+' : count}
    </span>
  );
}
